// extracted by mini-css-extract-plugin
export default {"container":"RecentCompletedAnime_container__xhVqm","left":"RecentCompletedAnime_left__1+xgG","right":"RecentCompletedAnime_right__8J2+Z"};